import { getPfeTileSeries } from 'widgets/signalTiles/pfeTile/components/chart/series/pfeTileSeries';

const upperBoundary = 100;
const lowerBoundary = -100;

const series = getPfeTileSeries(lowerBoundary, upperBoundary);

const domain: [number, number] = [-120, 120];

export const pfeTileProps = { upperBoundary, lowerBoundary, series, domain };
